<template>
    <div class="nct" v-if="brandDef">
        <span v-text="$ml.get('c2pAgreementText')" />
        <br />
        <a
            v-text="$ml.get('c2pAgreementTerms') + getTermsBrandCard.nameBrand"
            :href="getTermsBrandCard.termsUrl"
            target="_blank"
        />&nbsp;
        <span v-text="$ml.get('and')" />&nbsp;
        <a
            v-text="$ml.get('clickToPayAgreementPrivacyTerms')"
            target="_blank"
            :href="getTermsBrandCard.privaryUrl"
        />
    </div>
</template>

<script>
    export default {
        props: {
            brandDef: {
                type: String,
                default: ''
            }
        },

        computed: {
            getTermsBrandCard() {
                const brandCards = {
                    visa: {
                        nameBrand: 'Visa',
                        termsUrl: 'https://www.visa.com.br/legal/visa-checkout/terms-of-service.html',
                        privaryUrl: 'https://www.visa.com.br/legal/global-privacy-notice.html'
                    },
                    master: {
                        nameBrand: 'Mastercard',
                        termsUrl: 'https://www.mastercard.com/global/click-to-pay/pt-br/terms-of-use.html',
                        privaryUrl: 'https://www.mastercard.com/global/click-to-pay/pt-br/privacy-notice.html'
                    },
                };

                return brandCards[this.brandDef];
            },
        },
    };
</script>

<style lang="scss" scoped>
    .nct {
        display: block;
        padding: 16px;
        border-radius: 12px;
        background-color: #EFF1F3;

        span {
            font-size: 14px;
            font-weight: 500;
            color: #000000;
        }

        a {
            color: #0667CD;
            font-weight: 700;
            text-decoration: underline;
        }
    }
</style>